<template>
  <div class="content">

    <div class=" marg-bottom10">
      <div style="font-size:18px;font-weight: 700;padding-bottom: 10px;">关联活动</div>
      <van-search v-model="serachValue" placeholder="搜索活动" @input="goSearch()" />

      <div style="padding:10px 0">

        <div class="boxs">
          <div v-for="(item, index) in searchList" :key="index" class="box-item"
            :class="searchId == item.id ? 'opt' : ''" @click="onItem(item)">
            {{ item.title }}
          </div>
          <div v-show="searchList.length == 0" style="margin:auto">
            <van-empty image="search" image-size="60" description="暂无搜索结果" />
          </div>
        </div>
      </div>
    </div>
    <div class="marg-bottom10">
      <div style="font-size:18px;font-weight: 700;padding-bottom: 10px;">踩点标题</div>
      <van-field v-model="title" placeholder="请输入踩点标题" />
    </div>
    <div style="height: 100px;"></div>
    <div class="footers">
      <van-button type="info" size="large" @click="onSumbit()">更新</van-button>
    </div>

  </div>
</template>
<script>
import { Dialog } from 'vant'
export default {
  data () {
    return {
      title: '',
      id: '',
      target_id: '',
      serachValue: '',
      searchId: '',
      searchList: [],
    }
  },
  created () {
    this.id = this.$route.query.id
    this.searchId = this.$route.query.target_id || ''
    this.title = this.$route.query.title,
      this.serachValue = this.$route.query.target_title || ''
    this.goSearch()
  },
  methods: {
    goSearch () {
      this.$axios
        .get('/caidian/activity-list', {
          params: {
            keyword: this.serachValue,
          },
        })
        .then((res) => {
          let data = res.data.data
          for (let i = 0; i < data.length; i++) {
            if (data[i].version) {
              data[i].title = '【' + data[i].version + '】' + data[i].title
            }
          }
          this.searchList = res.data.data
        })
    },
    onItem (item) {
      this.serachValue = item.title
      this.searchId = item.id
    },
    onSumbit () {

      this.$axios
        .post('caidian/update', {
          id: this.id,
          artical_id: this.searchId,
          title: this.title,
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$toast(res.data.msg)
            return
          }

          Dialog.alert({
            message: res.data.msg,
          }).then(() => {
            this.$router.go(-1)
          })
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;

  .marg-bottom10 {
    margin-bottom: 10px;
  }

  .footers {
    position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  // justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
  z-index: 1000;
    
  }

  .boxs {
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;

    .box-item {
      display: block;
      width: 100%;
      padding: 5px;
      font-size: 14px;
      background: #f1f1f1;
      margin-top: 5px;
    }
  }

  .opt {
    background: coral !important;
  }
}
</style>